import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React from 'react';
import classNames from 'classnames/bind';
import { usePrepareMainTariffs } from "./hooks/usePrepareMainTariffs";
import { CarouselWithNavigation } from "../Carousel/components/CarouselWithNavigation";
import { Carousel } from "../Carousel";
import style from "./styles.module.pcss";
import { ENABLED_CAROUSEL } from "./constants";
var cn = classNames.bind(style);
export var TARIFF_SIZE = {
  1: 'l',
  2: 'm',
  3: 's'
};
var carouselSettings = {
  pagination: {
    renderBullet: function renderBullet(index, className) {
      return "<span style=\"background: #434856\" class=\"".concat(className, "\"></span>");
    },
    clickable: true
  },
  spaceBetween: 24
};
var navigationSettings = {
  btnClassname: cn('nav-btn'),
  nextBtnClassname: cn('next-btn'),
  prevBtnClassname: cn('prev-btn')
};
export var LayoutTariffsContainer = function LayoutTariffsContainer(_ref) {
  var children = _ref.children,
    tariffLength = _ref.tariffLength,
    isCarouselEnabled = _ref.isCarouselEnabled,
    withNavigation = _ref.withNavigation,
    _ref$enabledCarouselL = _ref.enabledCarouselLength,
    enabledCarouselLength = _ref$enabledCarouselL === void 0 ? ENABLED_CAROUSEL : _ref$enabledCarouselL;
  var CarouselComponent = withNavigation ? CarouselWithNavigation : Carousel;
  var slidesPerView = usePrepareMainTariffs();
  var showCarousel = isCarouselEnabled && tariffLength >= enabledCarouselLength;
  return showCarousel ? /*#__PURE__*/React.createElement("div", {
    className: cn('wrapper'),
    "data-t-id": "components-LayoutTariffs"
  }, /*#__PURE__*/React.createElement(CarouselComponent, _extends({
    className: cn('carousel'),
    settings: _objectSpread(_objectSpread({}, carouselSettings), {}, {
      slidesPerView: slidesPerView
    })
  }, withNavigation && _objectSpread({}, navigationSettings)), children)) : /*#__PURE__*/React.createElement("div", {
    className: cn('container', "container--".concat(TARIFF_SIZE[tariffLength] || 's'))
  }, children);
};